import type { SVGProps } from 'react'
import * as React from 'react'

const refreshIcon24 = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1012_3171)">
      <path d="M22.9988 4V10H16.999" stroke="#0D8251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M1 20V14H6.99974" stroke="#0D8251" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.50989 8.99959C4.01704 7.56637 4.87896 6.28499 6.01525 5.27501C7.15153 4.26502 8.52514 3.55935 10.0079 3.22385C11.4906 2.88834 13.0342 2.93393 14.4946 3.35636C15.955 3.77879 17.2845 4.5643 18.3592 5.63959L22.999 9.99959M1 13.9996L5.6398 18.3596C6.7145 19.4349 8.04407 20.2204 9.50444 20.6428C10.9648 21.0652 12.5084 21.1108 13.9911 20.7753C15.4739 20.4398 16.8475 19.7342 17.9838 18.7242C19.1201 17.7142 19.982 16.4328 20.4891 14.9996"
        stroke="#0D8251"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1012_3171">
        <rect width={23.999} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default refreshIcon24
